import { useState } from 'react';

import type { FeedbackGoal as FeedbackGoalType } from '@/types/simulations';
import tivyThumbsUp from '/images/tivy_thumbs_up.svg';
import FeedBackGoalsModal from './feedback-goals-modal';
import GoalMessage from './goal-message';

const FeedbackGoal = ({ goals = [] }: { goals: FeedbackGoalType[] }) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleGoalsModalClick = () => {
    setIsOpen(prev => !prev);
  };

  return (
    <div className="flex items-center gap-4 bg-white shadow-medium rounded-medium p-4">
      <img src={tivyThumbsUp} alt="Octopus achievement" width={104} />
      <div className="flex flex-col items-start gap-2">
        <GoalMessage goals={goals} onClick={handleGoalsModalClick} />
      </div>

      {isOpen && <FeedBackGoalsModal onClose={handleGoalsModalClick} goals={goals} />}
    </div>
  );
};

export default FeedbackGoal;
